<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.tags')}`">
              <div class="v-table">
                <TableServer type="tags" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-tag')}`">
              <TagForm v-if="fetcherAdminSchemas.forms['Tag']" />
            </b-tab>
            <b-tab
              v-if="tagId !== null && fetcherAdminTag.id > 0"
              :title="`${this.$i18n.t('JSON.tag')}#${tagId}`"
            >
              <TagForm
                v-if="fetcherAdminSchemas.forms['Tag']"
                :tag="fetcherAdminTag"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    TagForm: () => import('@/components/admin/fetcher/modals/forms/TagForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    tagId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminTag: (state) => state.fetcherAdminTag.fetcherAdminTag,
    }),

    modalId() {
      return 'tag';
    },
  },

  watch: {
    tagId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminTag();
      }
    },
  },

  methods: {
    ...mapActions(['getFetcherAdminTag']),

    async loadFetcherAdminTag() {
      try {
        await this.getFetcherAdminTag({
          params: {
            tid: this.tagId,
          },
        });

        // console.log('tag', this.tag);

        // success
        // console.log('success loading tag!');
      } catch (error) {
        // error
        // console.log('error loading tag!');
      }
    },

    onOpened() {
      if (this.tagId !== null) {
        this.loadFetcherAdminTag();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
